import { StoreModel } from '../../models/Index';

export default function homeButtonShow(Store: StoreModel, event: any) {
    Store.setValue({ hideBackToHome: false });
}
